import Vue from "vue";
import DatePicker from "vue2-datepicker";
import SortedTablePlugin from "vue-sorted-table";
import Paginate from "@/components/widgets/pagination.vue";
import Customers from "@/components/widgets/delivery";
import Customers2 from "@/components/widgets/customers";

import Loading from "@/components/widgets/Loading.vue";
import moment from "moment";

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>',
});

export default {
  components: {
    Customers,
    Customers2,
    DatePicker,
    Paginate,
    Loading,
  },
  data: function () {
    return {
      isEdit: false,
      invoiceUUID: null,
      uploadedFiles: [],
      selectedRows: [],
      isCustomerPopupOpen: false,
      isCustomerPopupOpen2: false,
      bank_account_list: [],
      vatRate: 0.07,
      form: {
        document_no: "",
        document_date: "",
        remark: "",
        vat_type: 1,
      },
      loading: false,
      customer_id: null,
      customer: {
        customer: {
          code: "",
          name: "",
          phone_number: "",
          company_name: "",
          tax_id: "",
          address: "",
        },
        document_no: "",
      },
      busy: false,
      advanced: false,
      status: null,
      createId: null,
      openedCreate: false,
      sortDesc: false,
      totalItem: 0,
      apiStatus: "ไม่พบข้อมูล",
      doc: {
        start: null,
        end: null,
      },
      duedate: {
        start: null,
        end: null,
      },
      debtStatus: [
        { text: "On hold", value: "onhold" },
        { text: "ค้างชำระ", value: "overdue" },
        { text: "ยกเลิก", value: "cancel" },
        { text: "ชำระแล้ว", value: "success" },
      ],
      perPage: 6,
      sortBy: "name",
      currentPage: 1,
      currentData: {},
      keyword: "",
      itemsTotal: 0,
      discount: 0,
      subtotal: 0,
      vat: 0,
      total: 0,
      fields: [
        {
          key: "idx",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          thStyle: { width: "5%" },
        },
        {
          key: "description",
          label: "รายละเอียด",
          sortable: false,
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "td-top text-xs-1/2",
          thStyle: { width: "20%" },
        },
        {
          key: "length",
          label: "ความยาว",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "quantity",
          label: "จำนวน",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "unit_name",
          label: "หน่วย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_length",
          label: "ปริมาณรวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "unit_price",
          label: "ราคา/หน่วย",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-right text-gray-400 td-top text-xs-1/2",
        },
        {
          key: "total_price",
          label: "ราคารวม",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          sortable: false,
          class: "text-right",
          thStyle: { width: "15%" },
        },
        {
          key: "action",
          label: "#",
          thClass: "font-weight-bold text-xs-1/2",
          tdClass: "text-gray-400 td-top text-xs-1/2",
          thStyle: { width: "5%" },
        },
      ],
      items: [],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    const uuid = this.$route.params.id;
    if (uuid) {
      this.isEdit = true;
      this.invoiceUUID = uuid;
      this.loadInvoice(uuid);
    }
  },
  methods: {
    // วันที่เอกสารเลือกได้ถึงวันนี้ — ห้ามวันอนาคต (เลขเอกสารยึดเดือนจากวันที่)
    disableFutureDates(date) {
      const endOfToday = new Date();
      endOfToday.setHours(23, 59, 59, 999);
      return date > endOfToday;
    },
    async loadInvoice(uuid) {
      try {
        this.loading = true;
        this.busy = true;

        const url = `${Vue.prototype.$host}/api/v1/document/tax-invoice-abb/${uuid}`;
        const res = await Vue.prototype.$axios.get(url);

        this.loading = false;
        this.busy = false;

        const inv = res?.data?.data;
        if (!inv) {
          this.onExceptionHandler("ไม่พบใบกำกับภาษี");
          return;
        }

        // ----- หัวเอกสาร -----
        this.form.document_no = inv.document_no || "";
        this.form.document_date = inv.document_date ? new Date(inv.document_date) : null;
        this.form.remark = inv.remark || "";
        this.form.vat_type = Number(inv.vat_type || 1);

        // ถ้าแบ็กเอนด์ส่ง vat_rate = 7 ให้แปลงเป็น 0.07
        if (inv.vat_rate != null) {
          const vr = this.toNum(inv.vat_rate);
          this.vatRate = vr > 1 ? vr / 100 : vr; // รองรับทั้ง 7 และ 0.07
        }

        const rawVatType = inv.vat_type;
        const parsed = parseInt(rawVatType, 10);
        this.form.vat_type = [0, 1, 2].includes(parsed) ? parsed : 1;

        // โหลดส่วนลด
        this.discount = this.toNum(inv.discount ?? 0);

        // ลูกค้า
        this.customer_id = inv.customer_id || null;
        const c = inv.customer_detail || {};
        this.customer = {
          ...this.customer,
          customer: {
            code: c.code || "",
            name: c.name || c.company_name || "",
            phone_number: c.phone_number || "",
            company_name: c.company_name || "",
            tax_id: c.tax_id || "",
            address: c.address || "",
          },
          document_no: inv.document_no || "-",
          id: inv.delivery_document_id || null,
        };

        // ----- รายการ -----
        const loaded = Array.isArray(inv.items) ? inv.items : [];
        this.items = loaded.map((it, i) => {
          const codePart = it.code_description ? `${it.code_description} ` : "";
          const descPart = it.description || "";

          // normalize ตัวเลขทั้งหมด
          const length = this.toNum(it.length);
          const quantity = this.toNum(it.qty != null ? it.qty : it.quantity);
          const unit_price = this.toNum(it.unit_price);
          const unit_name = it.unit_name || "";
          const discount = this.toNum(it.discount);
          const tax_rate_raw = (it.tax_rate != null) ? this.toNum(it.tax_rate) : 7;
          const tax_rate = tax_rate_raw > 1 ? tax_rate_raw : tax_rate_raw * 100; // เก็บเป็นเปอร์เซ็นต์ 7

          // คิดต่อแถวจากฐาน length/quantity/unit_price ทุกครั้ง
          const tmp = { length, quantity, unit_price };
          const { total_length, total_price } = this.computeLine(tmp);

          return {
            idx: i + 1,
            code: it.code || "",
            code_description: it.code_description || "",
            description: `${codePart}${descPart}`.trim(),

            length,
            quantity,
            total_length,
            unit_price,
            total_price,

            unit_name,
            type: it.type || 1,
            sku_id: it.sku_id || null,
            discount,
            tax_rate,    // เก็บเป็น 7 เพื่อส่งกลับฝั่ง API ได้
            remark: it.remark || null,
          };
        });

        // สรุปรวมหลัง set items แล้ว
        this.$nextTick(() => {
          this.calculateTotals();
        });

      } catch (err) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(err?.response?.data?.message || "เกิดข้อผิดพลาด");
      }
    },

    onConfirmUpdate() {
      this.$swal({
        width: "29rem",
        padding: "1.825em",
        html:
          '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">ยืนยันการแก้ไข</span>' +
          '<span class="text-base text-left text-gray-500">คุณต้องการบันทึกการแก้ไขใบกำกับภาษี (แบบย่อ) นี้หรือไม่</span>' +
          "</div>" +
          "</div>",
        customClass: {
          popup: "swal2-custom-rounded",
          closeButton: "text-3xl swal2-custom-close",
          actions: "justify-content-end",
          contant: "d-flex flex-row justify-content-around px-2",
          title: "d-none",
          confirmButton:
            "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton:
            "btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
        },
        allowOutsideClick: false,
        focusConfirm: false,
        cancelButtonColor: "#dc4a38",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        showCancelButton: true,
        showCloseButton: true,
      }).then((confirm) => {
        if (confirm.value) {
          this.onUpdate();
        }
      });
    },

    async onUpdate() {
      try {
        this.loading = true;
        this.busy = true;

        // backend update รองรับทั้ง array และ string ของ items
        // ที่นี่ส่ง JSON ให้ตรง ๆ
        const payload = {
          remark: this.form.remark ?? "",
          document_date: this.form.document_date
            ? moment(this.form.document_date).format("YYYY-MM-DD")
            : null,
          customer_id: this.customer_id || null,
          vat_type: this.form.vat_type,
          discount: Number(this.discount || 0),
          items_total: Number(this.itemsTotal || 0),
          subtotal: Number(this.subtotal || 0),
          vat: Number(this.vat || 0),
          grand_total: Number(this.total || 0),
          // ถ้าต้องการอนุญาตแก้สถานะผ่านหน้า UI สามารถเพิ่ม: status: 'issued' | 'cancelled' | ...
          items: this.items.map((x) => ({
            code: x.code ?? "",
            code_description: x.code_description ?? "",
            description: x.description ?? "",
            length: Number(x.length || 0),
            quantity: Number(x.quantity || 0),
            total_length: Number(x.total_length || 0),
            unit_price: Number(x.unit_price || 0),
            total_price: Number(x.total_price || 0),
            unit_name: x.unit_name ?? "",
            type: x.type ?? 1,
            sku_id: x.sku_id ?? null,
            discount: Number(x.discount || 0),
            tax_rate: typeof x.tax_rate === 'number' ? x.tax_rate : 7,
            remark: x.remark ?? null,
          })),
        };

        const url = `${Vue.prototype.$host}/api/v1/document/tax-invoice-abb/${this.invoiceUUID}`;
        const res = await Vue.prototype.$axios.put(url, payload);

        this.loading = false;
        this.busy = false;

        if (res) {
          this.$swal.close();
          this.$swal.fire({
            icon: "success",
            title: "บันทึกสำเร็จ",
            showConfirmButton: false,
            timer: 1200,
          });
          // ✅ ปิดแท็บหลังอัปเดตสำเร็จ
          setTimeout(() => {
            window.close();
          }, 1000);
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(error?.response?.data?.message || "เกิดข้อผิดพลาด");
      }
    },
    validateItemsAndSum() {
      let total = 0;
      let allValid = true;

      this.items.forEach((item, index) => {
        const price = parseFloat(item.total_price);
        if (isNaN(price) || price < 0) {
          allValid = false;
          // Mark item as invalid (optional if you want to show UI error)
          this.$set(item, "invalidPrice", true);
        } else {
          this.$set(item, "invalidPrice", false);
          total += price;
        }
      });
    },
    onDeliveryDocumentSelected(e) {
      this.isCustomerPopupOpen = false;

      if (e.data) {
        this.customer = e.data;
        this.customer_id = e.data.customer.id;
      }
      //โหลดรายการ
      const id = e.data.id
      this.onLoadBillItem(id)
    },
    onCustomerSelected(e) {
      this.isCustomerPopupOpen2 = false;

      if (e.data) {
        this.customer.document_no = "-";
        this.customer.customer = e.data;
        this.customer_id = e.data.id;
      }
    },
    onRemove(index) {
      if (index >= 0 && index < this.items.length) {
        this.items.splice(index, 1);
      }
      this.calculateTotals()
    },
    async requestCreditNote() {
      // 1. Validation เดิม
      if (!this.form.document_date) {
        this.onExceptionHandler("กรุณาเลือกวันทีเอกสาร");
        return;
      }
      if (!this.customer_id) {
        this.onExceptionHandler("กรุณาเลือกใบส่งสินค้าหรือเลือกลูกค้า");
        return;
      }
      if (this.items.length === 0) {
        this.onExceptionHandler("กรุณาใส่รายการอย่างน้อย 1 รายการ");
        return;
      }

      const invalidItem = this.items.find((item) => {
        return item.description === "" || Number(item.total_price) === 0;
      });
      if (invalidItem) {
        this.onExceptionHandler(
          "กรุณาระบุรายละเอียดและราคาสำหรับทุกรายการอย่างถูกต้อง"
        );
        return;
      }

      this.validateItemsAndSum();

      if (this.isEdit) {
        this.onConfirmUpdate();
      } else {
        this.onConfirmCreate();
      }
    },
    async onConfirmCreate() {
      this.$swal({
        width: "29rem",
        padding: "1.825em",
        html:
          '<div class="d-flex flex-row align-items-center">' +
          '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
          '<div class="d-flex flex-column">' +
          '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
          '<span class="text-base text-left text-gray-500">ท่านต้องการยืนยันการสร้าง `ใบกำกับภาษี (แบบย่อ)` ใช่หรือไม่ เอกสารที่สร้างจะไม่สามารถทำการแก้ไขได้เนื่องจากเป็นใบกำกับภาษี โดยสามารถ "ยกเลิก" ได้เท่านั้น</span>' +
          "</div>" +
          "</div>",
        customClass: {
          popup: "swal2-custom-rounded",
          closeButton: "text-3xl swal2-custom-close",
          actions: "justify-content-end",
          contant: "d-flex flex-row justify-content-around px-2",
          title: "d-none",
          confirmButton:
            "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          cancelButton:
            "btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
        },
        allowOutsideClick: false,
        focusConfirm: false,
        cancelButtonColor: "#dc4a38",
        cancelButtonText: "ยกเลิก",
        confirmButtonText: "ยืนยัน",
        showCancelButton: true,
        showCloseButton: true,
      }).then((confirm) => {
        if (confirm.value) {
          this.onCreate();
        }
      });
    },
    async onLoadBillItem(id) {
      try {
        this.loading = true;
        this.busy = true;

        let result = await Vue.prototype.$axios.get(
          `${Vue.prototype.$host}/api/v1/document/tax-invoice-prefill-item/${id}`
        );

        this.loading = false;
        this.busy = false;

        if (result) {
          const loaded = Array.isArray(result.data?.data) ? result.data.data : [];
          // merge code_description into description on load
          this.items = loaded.map((item, i) => {
            const codePart = item.code_description ? `${item.code_description} ` : "";
            const descPart = item.description || "";
            return {
              ...item,
              // Optional: keep your idx if the table uses it
              idx: i + 1,
              description: `${codePart}${descPart}`.trim()
            };
          });
          this.calculateTotals()
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(
          error.response?.data?.message || "เกิดข้อผิดพลาด"
        );
      }
    },
    async onCreate() {
      const formData = new FormData();
      formData.append("remark", this.form.remark ?? "");
      formData.append(
        "document_date",
        this.form.document_date
          ? moment(this.form.document_date).format("YYYY-MM-DD")
          : null
      );
      formData.append("customer_id", this.customer_id);
      if (this.customer.id) {
        formData.append("delivery_document_id", this.customer.id);
      }
      formData.append("items", JSON.stringify(this.items));

      formData.append("items_total", this.itemsTotal);
      formData.append("discount", this.discount);
      formData.append("subtotal", this.subtotal);
      formData.append("vat", this.vat);
      formData.append("vat_type", this.form.vat_type);
      formData.append("grand_total", this.total);

      try {
        this.loading = true;
        this.busy = true;

        let result = await Vue.prototype.$axios.post(
          `${Vue.prototype.$host}/api/v1/document/tax-invoice-abb`,
          formData
        );

        this.loading = false;
        this.busy = false;

        if (result) {
          this.uploadedFiles = [];
          alert("สร้างใบกำกับภาษี (แบบย่อ) สำเร็จ");
          this.$router.push("/tax/abb");
        }
      } catch (error) {
        this.loading = false;
        this.busy = false;
        this.apiStatus = "เกิดข้อผิดพลาด";
        this.onExceptionHandler(
          error.response?.data?.message || "เกิดข้อผิดพลาด"
        );
      }
    },
    onopenproduct() {
      var blank_row = {
        code: "",
        code_description: "",
        description: "",
        length: "0",
        quantity: "0",
        total_length: "0",
        unit_price: "0",
        total_price: "0",
        unit_name: "",
        type: 1,
        sku_id: null,
        is_insulator: false,
        isPE: true,
        isPU: false,
        thickness: null,
        insulator_material: null,
        insulator_detail: "",
        insulator_head: "",
        insulator_tail: "",

        is_curve: false,
        curve_weight: "",
        curve_start: "",
        curve_gap: "",
        curve_repeat: "",
      };
      this.items.splice(0, 0, blank_row);
    },
    onCopy(index) {
      const currentProducts = this.items;
      const targetProduct = currentProducts[index];

      var copied_row = {
        code: targetProduct.code,
        code_description: targetProduct.code_description,
        description: targetProduct.description,
        length: targetProduct.length,
        quantity: targetProduct.quantity,
        total_length: targetProduct.total_length,
        unit_price: targetProduct.unit_price,
        total_price: targetProduct.total_price,
        unit_name: targetProduct.unit_name,
        type: targetProduct.type,
        sku_id: targetProduct.sku_id,
        is_insulator: targetProduct.is_insulator,
        isPE: targetProduct.isPE,
        isPU: targetProduct.isPU,
        thickness: targetProduct.thickness,
        insulator_material: targetProduct.insulator_material,
        insulator_detail: targetProduct.insulator_detail,
        insulator_head: targetProduct.insulator_head,
        insulator_tail: targetProduct.insulator_tail,

        is_curve: targetProduct.is_curve,
        curve_weight: targetProduct.curve_weight,
        curve_start: targetProduct.curve_start,
        curve_gap: targetProduct.curve_gap,
        curve_repeat: targetProduct.curve_repeat,
      };
      this.items.splice(index + 1, 0, copied_row);

      this.calculateTotals();
    },
    lengthChanged(event, index) {
      const value = parseFloat(event) || 0;
      this.items[index].length = value;
      this.updateTotals(index);
    },
    quantityChanged(event, index) {
      const value = parseFloat(event) || 0;
      this.items[index].quantity = value;
      this.updateTotals(index);
    },
    unitPriceChanged(event, index) {
      const value = parseFloat(event) || 0;
      this.items[index].unit_price = value;
      this.updateTotals(index);
    },
    toNum(v) {
      const n = parseFloat(v);
      return isNaN(n) ? 0 : n;
    },
    round2(n) {
      return Math.round((Number(n) || 0) * 100) / 100;
    },
    computeLine(item) {   // คิด total_length / total_price ต่อแถว
      const len = this.toNum(item.length);
      const qty = this.toNum(item.quantity || item.qty);
      const up = this.toNum(item.unit_price);

      let total_length, total_price;
      if (len === 0) {
        total_length = qty;
        total_price = qty * up;
      } else {
        total_length = len * qty;
        total_price = total_length * up;
      }
      return {
        total_length: this.round2(total_length),
        total_price: this.round2(total_price),
      };
    },
    updateTotals(index) {
      const item = this.items[index];
      const { total_length, total_price } = this.computeLine(item);
      item.total_length = total_length;
      item.total_price = total_price;
      this.calculateTotals();
    },
    calculateTotals() {
      // 1) รวมจาก items ทั้งหมด (ก่อนส่วนลด)
      let itemsTotal = 0;
      this.items.forEach((item) => {
        const price = parseFloat(item.total_price) || 0;
        itemsTotal += price;
      });
      itemsTotal = this.round2(itemsTotal);
      this.itemsTotal = itemsTotal;

      // 2) ส่วนลด
      const discount = this.round2(this.toNum(this.discount));

      // 3) ฐาน = ยอดรวม - ส่วนลด
      let base = this.round2(itemsTotal - discount);
      if (base < 0) base = 0;

      // 4) คำนวณตามชนิด VAT
      if (this.form.vat_type === 1) {
        // แยก VAT
        this.subtotal = base;
        this.vat = this.round2(base * this.vatRate);
        this.total = this.round2(base + this.vat);
      } else if (this.form.vat_type === 2) {
        // รวม VAT
        const grand = base;
        const baseBeforeVat = this.round2(grand / (1 + this.vatRate));
        this.subtotal = baseBeforeVat;
        this.vat = this.round2(grand - baseBeforeVat);
        this.total = grand;
      } else {
        // ยกเว้น VAT
        this.subtotal = base;
        this.vat = 0;
        this.total = base;
      }
    }
  }
};
